import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const GoogleAuth = () => {
  const dispatch = useDispatch();
  const googleAuth_success = (res) => {
    const token = res.credential;
    try {
      const decodedToken = jwtDecode(token);
      const social_user = {
        first_name: decodedToken.given_name,
        last_name: decodedToken.family_name,
        email: decodedToken.email,
        avatar: decodedToken.picture,
      };
      dispatch({ type: "GET_SOCIAL_USER", payload: social_user });
    } catch (error) {
      console.error("Invalid token", error);
    }
  };
  const googleAuth_error = (err) => {
    console.log("errerrerr", err);
  };

  return (
    <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID}>
      <GoogleLogin
        onSuccess={googleAuth_success}
        onFailure={googleAuth_error}
        type="icon"
        size="large"
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleAuth;
